import { createContext, ReactElement, useContext, useReducer } from 'react';

export interface SectionContextInitialState {
  isSectionVisible: boolean | undefined;
  sectionKey: number;
}

export const InitialState: SectionContextInitialState = {
  isSectionVisible: undefined as boolean | undefined,
  sectionKey: 0 as number,
};

const reducer = (state: SectionContextInitialState, newState: Partial<SectionContextInitialState>) => ({
  ...state,
  ...newState,
});

const useSectionReducer = () => {
  const [state, dispatch] = useReducer(reducer, InitialState);

  const updateSectionContext = (newContext: Partial<SectionContextInitialState>) => dispatch(newContext);

  return { ...state, updateSectionContext };
};

type SectionContextState = ReturnType<typeof useSectionReducer>;

const SectionContext = createContext<SectionContextState | null>(null);

const SectionContextProvider = ({ children, sectionKey }: { children: ReactElement; sectionKey: number }) => {
  const { ...state } = useSectionReducer();

  return <SectionContext.Provider value={{ ...state, sectionKey }}>{children}</SectionContext.Provider>;
};

const useSectionContext = (): SectionContextState => {
  const context = useContext(SectionContext);
  if (!context) {
    throw new Error('useSectionContext must be used within an SectionContextProvider');
  }
  return context;
};

export { SectionContextProvider, useSectionContext };
